// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,json_types=true"
// @generated from file staticassets/v1/static_assets.proto (package staticassets.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_common_v1_annotations } from "../../common/v1/annotations_pb";
import type { PaginationArguments, PaginationArgumentsJson, PaginationPageInfo, PaginationPageInfoJson } from "../../common/v1/pagination_pb";
import { file_common_v1_pagination } from "../../common/v1/pagination_pb";
import type { Creator, CreatorJson } from "../../common/v1/types_pb";
import { file_common_v1_types } from "../../common/v1/types_pb";
import type { FieldMask, FieldMaskJson, StructJson, Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_field_mask, file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Status, StatusJson } from "../../google/rpc/status_pb";
import { file_google_rpc_status } from "../../google/rpc/status_pb";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file staticassets/v1/static_assets.proto.
 */
export const file_staticassets_v1_static_assets: GenFile =
	/*@__PURE__*/
	fileDesc(
		"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",
		[file_common_v1_annotations, file_common_v1_pagination, file_common_v1_types, file_google_protobuf_struct, file_google_protobuf_timestamp, file_google_protobuf_field_mask, file_google_rpc_status],
	);

/**
 * @generated from message staticassets.v1.GetUploadUrlRequest
 */
export type GetUploadUrlRequest = Message<"staticassets.v1.GetUploadUrlRequest"> & {
	/**
	 * @generated from field: optional google.protobuf.Struct metadata = 1;
	 */
	metadata?: JsonObject | undefined;

	/**
	 * ID is the unique identifier of the static asset.
	 *
	 * @generated from field: optional string id = 2;
	 */
	id?: string | undefined;
};

/**
 * @generated from message staticassets.v1.GetUploadUrlRequest
 */
export type GetUploadUrlRequestJson = {
	/**
	 * @generated from field: optional google.protobuf.Struct metadata = 1;
	 */
	metadata?: StructJson;

	/**
	 * ID is the unique identifier of the static asset.
	 *
	 * @generated from field: optional string id = 2;
	 */
	id?: string;
};

/**
 * Describes the message staticassets.v1.GetUploadUrlRequest.
 * Use `create(GetUploadUrlRequestSchema)` to create a new message.
 */
export const GetUploadUrlRequestSchema: GenMessage<GetUploadUrlRequest, { jsonType: GetUploadUrlRequestJson }> = /*@__PURE__*/ messageDesc(file_staticassets_v1_static_assets, 0);

/**
 * @generated from message staticassets.v1.GetUploadUrlResponse
 */
export type GetUploadUrlResponse = Message<"staticassets.v1.GetUploadUrlResponse"> & {
	/**
	 * @generated from field: string url = 1;
	 */
	url: string;

	/**
	 * @generated from field: string upload_url = 2;
	 */
	uploadUrl: string;

	/**
	 * @generated from field: map<string, string> headers = 3;
	 */
	headers: { [key: string]: string };

	/**
	 * @generated from field: string id = 4;
	 */
	id: string;
};

/**
 * @generated from message staticassets.v1.GetUploadUrlResponse
 */
export type GetUploadUrlResponseJson = {
	/**
	 * @generated from field: string url = 1;
	 */
	url?: string;

	/**
	 * @generated from field: string upload_url = 2;
	 */
	uploadUrl?: string;

	/**
	 * @generated from field: map<string, string> headers = 3;
	 */
	headers?: { [key: string]: string };

	/**
	 * @generated from field: string id = 4;
	 */
	id?: string;
};

/**
 * Describes the message staticassets.v1.GetUploadUrlResponse.
 * Use `create(GetUploadUrlResponseSchema)` to create a new message.
 */
export const GetUploadUrlResponseSchema: GenMessage<GetUploadUrlResponse, { jsonType: GetUploadUrlResponseJson }> = /*@__PURE__*/ messageDesc(file_staticassets_v1_static_assets, 1);

/**
 * @generated from message staticassets.v1.BulkGetUploadUrlRequest
 */
export type BulkGetUploadUrlRequest = Message<"staticassets.v1.BulkGetUploadUrlRequest"> & {
	/**
	 * @generated from field: repeated staticassets.v1.GetUploadUrlRequest requests = 1;
	 */
	requests: GetUploadUrlRequest[];
};

/**
 * @generated from message staticassets.v1.BulkGetUploadUrlRequest
 */
export type BulkGetUploadUrlRequestJson = {
	/**
	 * @generated from field: repeated staticassets.v1.GetUploadUrlRequest requests = 1;
	 */
	requests?: GetUploadUrlRequestJson[];
};

/**
 * Describes the message staticassets.v1.BulkGetUploadUrlRequest.
 * Use `create(BulkGetUploadUrlRequestSchema)` to create a new message.
 */
export const BulkGetUploadUrlRequestSchema: GenMessage<BulkGetUploadUrlRequest, { jsonType: BulkGetUploadUrlRequestJson }> = /*@__PURE__*/ messageDesc(file_staticassets_v1_static_assets, 2);

/**
 * @generated from message staticassets.v1.BulkGetUploadUrlResponse
 */
export type BulkGetUploadUrlResponse = Message<"staticassets.v1.BulkGetUploadUrlResponse"> & {
	/**
	 * @generated from field: repeated staticassets.v1.GetUploadUrlResponse response = 1;
	 */
	response: GetUploadUrlResponse[];
};

/**
 * @generated from message staticassets.v1.BulkGetUploadUrlResponse
 */
export type BulkGetUploadUrlResponseJson = {
	/**
	 * @generated from field: repeated staticassets.v1.GetUploadUrlResponse response = 1;
	 */
	response?: GetUploadUrlResponseJson[];
};

/**
 * Describes the message staticassets.v1.BulkGetUploadUrlResponse.
 * Use `create(BulkGetUploadUrlResponseSchema)` to create a new message.
 */
export const BulkGetUploadUrlResponseSchema: GenMessage<BulkGetUploadUrlResponse, { jsonType: BulkGetUploadUrlResponseJson }> = /*@__PURE__*/ messageDesc(file_staticassets_v1_static_assets, 3);

/**
 * @generated from message staticassets.v1.StaticAsset
 */
export type StaticAsset = Message<"staticassets.v1.StaticAsset"> & {
	/**
	 * ID is the unique identifier of the static asset.
	 *
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * Name is the user-provided name for the static asset.
	 *
	 * @generated from field: string name = 2;
	 */
	name: string;

	/**
	 * Description is an optional description of the static asset.
	 *
	 * @generated from field: string description = 3;
	 */
	description: string;

	/**
	 * Org ID is the organization that the static asset belongs to.
	 *
	 * @generated from field: string org_id = 4;
	 */
	orgId: string;

	/**
	 * Workspace ID is the workspace that the static asset belongs to. Must be associated with the org_id.
	 *
	 * @generated from field: string workspace_id = 5;
	 */
	workspaceId: string;

	/**
	 * Creator is the person who created the static asset.
	 *
	 * @generated from field: common.v1.Creator creator = 6;
	 */
	creator?: Creator | undefined;

	/**
	 * State respresents the current state of the static asset. Valid values are active, archived or draft.
	 *
	 * @generated from field: string state = 7;
	 */
	state: string;

	/**
	 * The name of the actual file uploaded.
	 *
	 * @generated from field: string file_name = 8;
	 */
	fileName: string;

	/**
	 * The size of the file uploaded.
	 *
	 * @generated from field: float file_size = 9;
	 */
	fileSize: number;

	/**
	 * The mime type of the uploaded file.
	 *
	 * @generated from field: string mime_type = 10;
	 */
	mimeType: string;

	/**
	 * The id of the static asset entry created on file uploaded.
	 *
	 * @generated from field: string static_asset_id = 11;
	 */
	staticAssetId: string;

	/**
	 * The upload url in storage associated with the uploaded file.
	 *
	 * @generated from field: string upload_url = 12;
	 */
	uploadUrl: string;

	/**
	 * Created At is the timestamp when the static asset was created.
	 *
	 * @generated from field: google.protobuf.Timestamp created_at = 13;
	 */
	createdAt?: Timestamp | undefined;

	/**
	 * Updated At is the timestamp when the static asset was last updated.
	 *
	 * @generated from field: google.protobuf.Timestamp updated_at = 14;
	 */
	updatedAt?: Timestamp | undefined;

	/**
	 * The path to the folder where the static asset is located.
	 *
	 * @generated from field: string folder_path = 15;
	 */
	folderPath: string;

	/**
	 * The ID of the folder where the static asset is located.
	 *
	 * @generated from field: string folder_id = 16;
	 */
	folderId: string;
};

/**
 * @generated from message staticassets.v1.StaticAsset
 */
export type StaticAssetJson = {
	/**
	 * ID is the unique identifier of the static asset.
	 *
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * Name is the user-provided name for the static asset.
	 *
	 * @generated from field: string name = 2;
	 */
	name?: string;

	/**
	 * Description is an optional description of the static asset.
	 *
	 * @generated from field: string description = 3;
	 */
	description?: string;

	/**
	 * Org ID is the organization that the static asset belongs to.
	 *
	 * @generated from field: string org_id = 4;
	 */
	orgId?: string;

	/**
	 * Workspace ID is the workspace that the static asset belongs to. Must be associated with the org_id.
	 *
	 * @generated from field: string workspace_id = 5;
	 */
	workspaceId?: string;

	/**
	 * Creator is the person who created the static asset.
	 *
	 * @generated from field: common.v1.Creator creator = 6;
	 */
	creator?: CreatorJson;

	/**
	 * State respresents the current state of the static asset. Valid values are active, archived or draft.
	 *
	 * @generated from field: string state = 7;
	 */
	state?: string;

	/**
	 * The name of the actual file uploaded.
	 *
	 * @generated from field: string file_name = 8;
	 */
	fileName?: string;

	/**
	 * The size of the file uploaded.
	 *
	 * @generated from field: float file_size = 9;
	 */
	fileSize?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * The mime type of the uploaded file.
	 *
	 * @generated from field: string mime_type = 10;
	 */
	mimeType?: string;

	/**
	 * The id of the static asset entry created on file uploaded.
	 *
	 * @generated from field: string static_asset_id = 11;
	 */
	staticAssetId?: string;

	/**
	 * The upload url in storage associated with the uploaded file.
	 *
	 * @generated from field: string upload_url = 12;
	 */
	uploadUrl?: string;

	/**
	 * Created At is the timestamp when the static asset was created.
	 *
	 * @generated from field: google.protobuf.Timestamp created_at = 13;
	 */
	createdAt?: TimestampJson;

	/**
	 * Updated At is the timestamp when the static asset was last updated.
	 *
	 * @generated from field: google.protobuf.Timestamp updated_at = 14;
	 */
	updatedAt?: TimestampJson;

	/**
	 * The path to the folder where the static asset is located.
	 *
	 * @generated from field: string folder_path = 15;
	 */
	folderPath?: string;

	/**
	 * The ID of the folder where the static asset is located.
	 *
	 * @generated from field: string folder_id = 16;
	 */
	folderId?: string;
};

/**
 * Describes the message staticassets.v1.StaticAsset.
 * Use `create(StaticAssetSchema)` to create a new message.
 */
export const StaticAssetSchema: GenMessage<StaticAsset, { jsonType: StaticAssetJson }> = /*@__PURE__*/ messageDesc(file_staticassets_v1_static_assets, 4);

/**
 * @generated from message staticassets.v1.CreateStaticAssetRequest
 */
export type CreateStaticAssetRequest = Message<"staticassets.v1.CreateStaticAssetRequest"> & {
	/**
	 * @generated from field: staticassets.v1.StaticAsset static_asset = 1;
	 */
	staticAsset?: StaticAsset | undefined;
};

/**
 * @generated from message staticassets.v1.CreateStaticAssetRequest
 */
export type CreateStaticAssetRequestJson = {
	/**
	 * @generated from field: staticassets.v1.StaticAsset static_asset = 1;
	 */
	staticAsset?: StaticAssetJson;
};

/**
 * Describes the message staticassets.v1.CreateStaticAssetRequest.
 * Use `create(CreateStaticAssetRequestSchema)` to create a new message.
 */
export const CreateStaticAssetRequestSchema: GenMessage<CreateStaticAssetRequest, { jsonType: CreateStaticAssetRequestJson }> = /*@__PURE__*/ messageDesc(file_staticassets_v1_static_assets, 5);

/**
 * @generated from message staticassets.v1.CreateStaticAssetResponse
 */
export type CreateStaticAssetResponse = Message<"staticassets.v1.CreateStaticAssetResponse"> & {
	/**
	 * @generated from field: staticassets.v1.StaticAsset static_asset = 1;
	 */
	staticAsset?: StaticAsset | undefined;
};

/**
 * @generated from message staticassets.v1.CreateStaticAssetResponse
 */
export type CreateStaticAssetResponseJson = {
	/**
	 * @generated from field: staticassets.v1.StaticAsset static_asset = 1;
	 */
	staticAsset?: StaticAssetJson;
};

/**
 * Describes the message staticassets.v1.CreateStaticAssetResponse.
 * Use `create(CreateStaticAssetResponseSchema)` to create a new message.
 */
export const CreateStaticAssetResponseSchema: GenMessage<CreateStaticAssetResponse, { jsonType: CreateStaticAssetResponseJson }> = /*@__PURE__*/ messageDesc(file_staticassets_v1_static_assets, 6);

/**
 * @generated from message staticassets.v1.CreateStaticAssetsRequest
 */
export type CreateStaticAssetsRequest = Message<"staticassets.v1.CreateStaticAssetsRequest"> & {
	/**
	 * @generated from field: repeated staticassets.v1.StaticAsset static_assets = 1;
	 */
	staticAssets: StaticAsset[];
};

/**
 * @generated from message staticassets.v1.CreateStaticAssetsRequest
 */
export type CreateStaticAssetsRequestJson = {
	/**
	 * @generated from field: repeated staticassets.v1.StaticAsset static_assets = 1;
	 */
	staticAssets?: StaticAssetJson[];
};

/**
 * Describes the message staticassets.v1.CreateStaticAssetsRequest.
 * Use `create(CreateStaticAssetsRequestSchema)` to create a new message.
 */
export const CreateStaticAssetsRequestSchema: GenMessage<CreateStaticAssetsRequest, { jsonType: CreateStaticAssetsRequestJson }> = /*@__PURE__*/ messageDesc(file_staticassets_v1_static_assets, 7);

/**
 * @generated from message staticassets.v1.CreateStaticAssetsResponse
 */
export type CreateStaticAssetsResponse = Message<"staticassets.v1.CreateStaticAssetsResponse"> & {
	/**
	 * @generated from field: repeated staticassets.v1.StaticAsset static_assets = 1;
	 */
	staticAssets: StaticAsset[];
};

/**
 * @generated from message staticassets.v1.CreateStaticAssetsResponse
 */
export type CreateStaticAssetsResponseJson = {
	/**
	 * @generated from field: repeated staticassets.v1.StaticAsset static_assets = 1;
	 */
	staticAssets?: StaticAssetJson[];
};

/**
 * Describes the message staticassets.v1.CreateStaticAssetsResponse.
 * Use `create(CreateStaticAssetsResponseSchema)` to create a new message.
 */
export const CreateStaticAssetsResponseSchema: GenMessage<CreateStaticAssetsResponse, { jsonType: CreateStaticAssetsResponseJson }> = /*@__PURE__*/ messageDesc(file_staticassets_v1_static_assets, 8);

/**
 * @generated from message staticassets.v1.ListStaticAssetsRequest
 */
export type ListStaticAssetsRequest = Message<"staticassets.v1.ListStaticAssetsRequest"> & {
	/**
	 * Org ID is the organization that the static assets belong to.
	 *
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * Workspace ID is the workspace that the static assets belong to. Must be associated with the org_id.
	 *
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * Show only static assets created by this creator id.
	 *
	 * @generated from field: string creator_id = 3;
	 */
	creatorId: string;

	/**
	 * Show only static assets that include this prefix in the name.
	 *
	 * @generated from field: string name_prefix = 4;
	 */
	namePrefix: string;

	/**
	 * Show only static assets scoped to the requested asset states.
	 *
	 * @generated from field: repeated string states = 6;
	 */
	states: string[];

	/**
	 * Pagination arguments.
	 *
	 * @generated from field: common.v1.PaginationArguments pagination = 5;
	 */
	pagination?: PaginationArguments | undefined;

	/**
	 * Show only static assets scoped to the requested categories
	 *
	 * @generated from field: repeated string categories = 7;
	 */
	categories: string[];

	/**
	 * Show only static assets belonging to this folder path.
	 *
	 * @generated from field: optional string folder_path = 8;
	 */
	folderPath?: string | undefined;
};

/**
 * @generated from message staticassets.v1.ListStaticAssetsRequest
 */
export type ListStaticAssetsRequestJson = {
	/**
	 * Org ID is the organization that the static assets belong to.
	 *
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * Workspace ID is the workspace that the static assets belong to. Must be associated with the org_id.
	 *
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * Show only static assets created by this creator id.
	 *
	 * @generated from field: string creator_id = 3;
	 */
	creatorId?: string;

	/**
	 * Show only static assets that include this prefix in the name.
	 *
	 * @generated from field: string name_prefix = 4;
	 */
	namePrefix?: string;

	/**
	 * Show only static assets scoped to the requested asset states.
	 *
	 * @generated from field: repeated string states = 6;
	 */
	states?: string[];

	/**
	 * Pagination arguments.
	 *
	 * @generated from field: common.v1.PaginationArguments pagination = 5;
	 */
	pagination?: PaginationArgumentsJson;

	/**
	 * Show only static assets scoped to the requested categories
	 *
	 * @generated from field: repeated string categories = 7;
	 */
	categories?: string[];

	/**
	 * Show only static assets belonging to this folder path.
	 *
	 * @generated from field: optional string folder_path = 8;
	 */
	folderPath?: string;
};

/**
 * Describes the message staticassets.v1.ListStaticAssetsRequest.
 * Use `create(ListStaticAssetsRequestSchema)` to create a new message.
 */
export const ListStaticAssetsRequestSchema: GenMessage<ListStaticAssetsRequest, { jsonType: ListStaticAssetsRequestJson }> = /*@__PURE__*/ messageDesc(file_staticassets_v1_static_assets, 9);

/**
 * @generated from message staticassets.v1.ListStaticAssetsResponse
 */
export type ListStaticAssetsResponse = Message<"staticassets.v1.ListStaticAssetsResponse"> & {
	/**
	 * List of static assets that match the query.
	 *
	 * @generated from field: repeated staticassets.v1.StaticAsset static_assets = 1;
	 */
	staticAssets: StaticAsset[];

	/**
	 * Pagination information.
	 *
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo | undefined;
};

/**
 * @generated from message staticassets.v1.ListStaticAssetsResponse
 */
export type ListStaticAssetsResponseJson = {
	/**
	 * List of static assets that match the query.
	 *
	 * @generated from field: repeated staticassets.v1.StaticAsset static_assets = 1;
	 */
	staticAssets?: StaticAssetJson[];

	/**
	 * Pagination information.
	 *
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message staticassets.v1.ListStaticAssetsResponse.
 * Use `create(ListStaticAssetsResponseSchema)` to create a new message.
 */
export const ListStaticAssetsResponseSchema: GenMessage<ListStaticAssetsResponse, { jsonType: ListStaticAssetsResponseJson }> = /*@__PURE__*/ messageDesc(file_staticassets_v1_static_assets, 10);

/**
 * @generated from message staticassets.v1.UpdateStaticAssetRequest
 */
export type UpdateStaticAssetRequest = Message<"staticassets.v1.UpdateStaticAssetRequest"> & {
	/**
	 * @generated from field: staticassets.v1.StaticAsset static_asset = 1;
	 */
	staticAsset?: StaticAsset | undefined;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 2;
	 */
	mask?: FieldMask | undefined;
};

/**
 * @generated from message staticassets.v1.UpdateStaticAssetRequest
 */
export type UpdateStaticAssetRequestJson = {
	/**
	 * @generated from field: staticassets.v1.StaticAsset static_asset = 1;
	 */
	staticAsset?: StaticAssetJson;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 2;
	 */
	mask?: FieldMaskJson;
};

/**
 * Describes the message staticassets.v1.UpdateStaticAssetRequest.
 * Use `create(UpdateStaticAssetRequestSchema)` to create a new message.
 */
export const UpdateStaticAssetRequestSchema: GenMessage<UpdateStaticAssetRequest, { jsonType: UpdateStaticAssetRequestJson }> = /*@__PURE__*/ messageDesc(file_staticassets_v1_static_assets, 11);

/**
 * @generated from message staticassets.v1.UpdateStaticAssetResponse
 */
export type UpdateStaticAssetResponse = Message<"staticassets.v1.UpdateStaticAssetResponse"> & {
	/**
	 * @generated from field: staticassets.v1.StaticAsset static_asset = 1;
	 */
	staticAsset?: StaticAsset | undefined;
};

/**
 * @generated from message staticassets.v1.UpdateStaticAssetResponse
 */
export type UpdateStaticAssetResponseJson = {
	/**
	 * @generated from field: staticassets.v1.StaticAsset static_asset = 1;
	 */
	staticAsset?: StaticAssetJson;
};

/**
 * Describes the message staticassets.v1.UpdateStaticAssetResponse.
 * Use `create(UpdateStaticAssetResponseSchema)` to create a new message.
 */
export const UpdateStaticAssetResponseSchema: GenMessage<UpdateStaticAssetResponse, { jsonType: UpdateStaticAssetResponseJson }> = /*@__PURE__*/ messageDesc(file_staticassets_v1_static_assets, 12);

/**
 * @generated from message staticassets.v1.GetStaticAssetRequest
 */
export type GetStaticAssetRequest = Message<"staticassets.v1.GetStaticAssetRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;
};

/**
 * @generated from message staticassets.v1.GetStaticAssetRequest
 */
export type GetStaticAssetRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;
};

/**
 * Describes the message staticassets.v1.GetStaticAssetRequest.
 * Use `create(GetStaticAssetRequestSchema)` to create a new message.
 */
export const GetStaticAssetRequestSchema: GenMessage<GetStaticAssetRequest, { jsonType: GetStaticAssetRequestJson }> = /*@__PURE__*/ messageDesc(file_staticassets_v1_static_assets, 13);

/**
 * @generated from message staticassets.v1.GetStaticAssetResponse
 */
export type GetStaticAssetResponse = Message<"staticassets.v1.GetStaticAssetResponse"> & {
	/**
	 * @generated from field: staticassets.v1.StaticAsset static_asset = 1;
	 */
	staticAsset?: StaticAsset | undefined;
};

/**
 * @generated from message staticassets.v1.GetStaticAssetResponse
 */
export type GetStaticAssetResponseJson = {
	/**
	 * @generated from field: staticassets.v1.StaticAsset static_asset = 1;
	 */
	staticAsset?: StaticAssetJson;
};

/**
 * Describes the message staticassets.v1.GetStaticAssetResponse.
 * Use `create(GetStaticAssetResponseSchema)` to create a new message.
 */
export const GetStaticAssetResponseSchema: GenMessage<GetStaticAssetResponse, { jsonType: GetStaticAssetResponseJson }> = /*@__PURE__*/ messageDesc(file_staticassets_v1_static_assets, 14);

/**
 * @generated from message staticassets.v1.DeleteStaticAssetRequest
 */
export type DeleteStaticAssetRequest = Message<"staticassets.v1.DeleteStaticAssetRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;
};

/**
 * @generated from message staticassets.v1.DeleteStaticAssetRequest
 */
export type DeleteStaticAssetRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;
};

/**
 * Describes the message staticassets.v1.DeleteStaticAssetRequest.
 * Use `create(DeleteStaticAssetRequestSchema)` to create a new message.
 */
export const DeleteStaticAssetRequestSchema: GenMessage<DeleteStaticAssetRequest, { jsonType: DeleteStaticAssetRequestJson }> = /*@__PURE__*/ messageDesc(file_staticassets_v1_static_assets, 15);

/**
 * @generated from message staticassets.v1.DeleteStaticAssetResponse
 */
export type DeleteStaticAssetResponse = Message<"staticassets.v1.DeleteStaticAssetResponse"> & {};

/**
 * @generated from message staticassets.v1.DeleteStaticAssetResponse
 */
export type DeleteStaticAssetResponseJson = {};

/**
 * Describes the message staticassets.v1.DeleteStaticAssetResponse.
 * Use `create(DeleteStaticAssetResponseSchema)` to create a new message.
 */
export const DeleteStaticAssetResponseSchema: GenMessage<DeleteStaticAssetResponse, { jsonType: DeleteStaticAssetResponseJson }> = /*@__PURE__*/ messageDesc(file_staticassets_v1_static_assets, 16);

/**
 * @generated from message staticassets.v1.BulkUpdateStaticAssetRequest
 */
export type BulkUpdateStaticAssetRequest = Message<"staticassets.v1.BulkUpdateStaticAssetRequest"> & {
	/**
	 * @generated from field: repeated staticassets.v1.UpdateStaticAssetRequest requests = 1;
	 */
	requests: UpdateStaticAssetRequest[];
};

/**
 * @generated from message staticassets.v1.BulkUpdateStaticAssetRequest
 */
export type BulkUpdateStaticAssetRequestJson = {
	/**
	 * @generated from field: repeated staticassets.v1.UpdateStaticAssetRequest requests = 1;
	 */
	requests?: UpdateStaticAssetRequestJson[];
};

/**
 * Describes the message staticassets.v1.BulkUpdateStaticAssetRequest.
 * Use `create(BulkUpdateStaticAssetRequestSchema)` to create a new message.
 */
export const BulkUpdateStaticAssetRequestSchema: GenMessage<BulkUpdateStaticAssetRequest, { jsonType: BulkUpdateStaticAssetRequestJson }> = /*@__PURE__*/ messageDesc(file_staticassets_v1_static_assets, 17);

/**
 * @generated from message staticassets.v1.BulkUpdateStaticAssetResponse
 */
export type BulkUpdateStaticAssetResponse = Message<"staticassets.v1.BulkUpdateStaticAssetResponse"> & {
	/**
	 * @generated from field: staticassets.v1.UpdateStaticAssetResponse response = 1;
	 */
	response?: UpdateStaticAssetResponse | undefined;

	/**
	 * @generated from field: google.rpc.Status status = 2;
	 */
	status?: Status | undefined;
};

/**
 * @generated from message staticassets.v1.BulkUpdateStaticAssetResponse
 */
export type BulkUpdateStaticAssetResponseJson = {
	/**
	 * @generated from field: staticassets.v1.UpdateStaticAssetResponse response = 1;
	 */
	response?: UpdateStaticAssetResponseJson;

	/**
	 * @generated from field: google.rpc.Status status = 2;
	 */
	status?: StatusJson;
};

/**
 * Describes the message staticassets.v1.BulkUpdateStaticAssetResponse.
 * Use `create(BulkUpdateStaticAssetResponseSchema)` to create a new message.
 */
export const BulkUpdateStaticAssetResponseSchema: GenMessage<BulkUpdateStaticAssetResponse, { jsonType: BulkUpdateStaticAssetResponseJson }> = /*@__PURE__*/ messageDesc(file_staticassets_v1_static_assets, 18);

/**
 * @generated from service staticassets.v1.StaticAssetsService
 */
export const StaticAssetsService: GenService<{
	/**
	 * @generated from rpc staticassets.v1.StaticAssetsService.GetUploadUrl
	 */
	getUploadUrl: {
		methodKind: "unary";
		input: typeof GetUploadUrlRequestSchema;
		output: typeof GetUploadUrlResponseSchema;
	};
	/**
	 * @generated from rpc staticassets.v1.StaticAssetsService.BulkGetUploadUrl
	 */
	bulkGetUploadUrl: {
		methodKind: "unary";
		input: typeof BulkGetUploadUrlRequestSchema;
		output: typeof BulkGetUploadUrlResponseSchema;
	};
	/**
	 * @generated from rpc staticassets.v1.StaticAssetsService.CreateStaticAsset
	 */
	createStaticAsset: {
		methodKind: "unary";
		input: typeof CreateStaticAssetRequestSchema;
		output: typeof CreateStaticAssetResponseSchema;
	};
	/**
	 * @generated from rpc staticassets.v1.StaticAssetsService.CreateStaticAssets
	 */
	createStaticAssets: {
		methodKind: "unary";
		input: typeof CreateStaticAssetsRequestSchema;
		output: typeof CreateStaticAssetsResponseSchema;
	};
	/**
	 * @generated from rpc staticassets.v1.StaticAssetsService.ListStaticAssets
	 */
	listStaticAssets: {
		methodKind: "unary";
		input: typeof ListStaticAssetsRequestSchema;
		output: typeof ListStaticAssetsResponseSchema;
	};
	/**
	 * @generated from rpc staticassets.v1.StaticAssetsService.UpdateStaticAsset
	 */
	updateStaticAsset: {
		methodKind: "unary";
		input: typeof UpdateStaticAssetRequestSchema;
		output: typeof UpdateStaticAssetResponseSchema;
	};
	/**
	 * @generated from rpc staticassets.v1.StaticAssetsService.GetStaticAsset
	 */
	getStaticAsset: {
		methodKind: "unary";
		input: typeof GetStaticAssetRequestSchema;
		output: typeof GetStaticAssetResponseSchema;
	};
	/**
	 * @generated from rpc staticassets.v1.StaticAssetsService.DeleteStaticAsset
	 */
	deleteStaticAsset: {
		methodKind: "unary";
		input: typeof DeleteStaticAssetRequestSchema;
		output: typeof DeleteStaticAssetResponseSchema;
	};
	/**
	 * @generated from rpc staticassets.v1.StaticAssetsService.BulkUpdateStaticAsset
	 */
	bulkUpdateStaticAsset: {
		methodKind: "server_streaming";
		input: typeof BulkUpdateStaticAssetRequestSchema;
		output: typeof BulkUpdateStaticAssetResponseSchema;
	};
}> = /*@__PURE__*/ serviceDesc(file_staticassets_v1_static_assets, 0);
